import { Injectable } from '@angular/core';
import { ApiService } from 'app/modules/common/services/api.service';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class ReportsLeaveReportService {

  constructor(
    private _apiService: ApiService
  ) { }

  public getReportTemplateList(): Observable<RestResponse> {
    const url = `${API.LeaveReport.getTemplateReports}`;
    return this._apiService.get(url);
  }

  public getReportTemplateListById(templateId: number): Observable<RestResponse> {
    let url = `${API.LeaveReport.getTemplateReportsById}`;
    url = url.replace('{id}', templateId.toString());
    return this._apiService.get(url);
  }

  public getAllTemplateNames(): Observable<RestResponse> {
    let url = `${API.LeaveReport.getAllTemplateNames}`;
    return this._apiService.get(url);
  }

  public addTemplate(formcontrolValues : any): Observable<RestResponse> {    
    let url = `${API.LeaveReport.addTemplateReport}`;
    return this._apiService.post(url,formcontrolValues);
  }

  public updateTemplate(updatedFormcontrolValues : any): Observable<RestResponse> {
    let url = `${API.LeaveReport.updateTemplateReport}`;
    return this._apiService.put(url,updatedFormcontrolValues);
  }

  public deleteTemplate(id: number): Observable<RestResponse> {
    let url = `${API.LeaveReport.deleteTemplateReport}`;
    url = url.replace('{id}', id.toString());
    return this._apiService.delete(url);
  }
}





